
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetogoataxi() {



    const cardData =
    {
        keyword: 'Pune to Goa Taxi',
        heading: 'Meghana Cab : Pune to Goa Taxi',
        headingDescription: 'Meghana Cab offers Pune to Goa Taxi services, ensuring a comfortable, memorable, and stress-free journey to the beautiful beaches and vibrant culture of Goa. Whether you are heading for a family vacation, a friends’ road trip, or a romantic getaway, our clean and well-maintained taxis with experienced drivers guarantee a smooth and safe ride. Choose from a variety of vehicle options—hatchbacks, sedans, SUVs, even tempo travellers—to suit your group size and preferences, and enjoy transparent pricing, punctual pickups, and 24/7 customer support. Book your Pune to Goa Taxi with Meghana Cab and embark on a scenic, hassle-free trip filled with sunshine, sea, and serenity.',


        top: 'Top Places to Visit in Goa with Meghana Cab',

"topPlaces": [
  {
    "title": "Calangute and Baga Beaches",
    "description": "Goa’s most iconic and bustling beaches, Calangute and Baga offer extensive stretches of golden sand lined with shacks, water-sport options such as parasailing and jet-skiing, and vibrant nightlife. Calangute attracts families and tourists during the day, while Baga is known for its lively evening ambience, shacks, and party scene."
  },
  {
    "title": "Old Goa Churches",
    "description": "A UNESCO World Heritage site, Old Goa is home to majestic Portuguese-era churches and basilicas. The Basilica of Bom Jesus houses the tomb of St. Francis Xavier, featuring elaborate Baroque architecture. Nearby, the Sé Cathedral—the largest in India—and Church of Our Lady of the Immaculate Conception showcase colonial religious grandeur."
  },
  {
    "title": "Dudhsagar Falls & Mollem National Park",
    "description": "Located within Bhagwan Mahaveer Sanctuary, Dudhsagar Falls is a spectacular four-tiered cascade reaching 310 m, best seen during post-monsoon when full and roaring. The surrounding Mollem forest also contains Tambdi Surla Temple and Devil’s Canyon, offering scenic treks amid rich Western Ghats biodiversity."
  },
  {
    "title": "Chapora and Fort Aguada",
    "description": "Overlooking the Arabian Sea, Chapora Fort provides panoramic sunset views and scenic cliffside ruins popularized by Bollywood. Fort Aguada, a 17th-century Portuguese fort with a lighthouse near Sinquerim Beach, offers sweeping coastal vistas and historical insight into Goa’s maritime heritage."
  },
  {
    "title": "Anjuna Market & Beach",
    "description": "Anjuna Beach is renowned for its bohemian vibe and water-sports activities. Every Wednesday, its famous flea market offers a colorful array of handicrafts, clothing, jewelry, and food stalls—a cultural experience reflecting Goa’s free-spirited atmosphere."
  },
  {
    "title": "Panaji & Fontainhas Latin Quarter",
    "description": "Goa’s capital, Panaji, features serene riverfronts with cruise boats and the iconic Miramar promenade. Fontainhas, the heritage Latin Quarter, offers narrow lanes lined with colourful Portuguese villas, art galleries, boutique cafes, and local markets, capturing Goa’s colonial charm."
  },
  {
    "title": "Bondla Wildlife Sanctuary",
    "description": "Located in North Goa near Panaji, Bondla is Goa’s only zoo-backed wildlife sanctuary. Spanning approximately 8 km², it houses rescued wildlife like leopards and bears, native birds including the Malabar grey hornbill, and lush vegetation—ideal for family outings and wildlife education."
  },
  {
    "title": "Spice Plantations & Tambdi Surla Temple",
    "description": "Goa’s spice plantations, located near Ponda, offer guided tours amidst coconut, pepper, and cashew orchards, often combined with visits to the 12th-century Kadamba-period Tambdi Surla Temple—one of Goa’s oldest active shrines set in a serene forest environment."
  },
  {
    "title": "Dona Paula Viewpoint",
    "description": "A scenic meeting point of the Mandovi and Zuari Rivers, Dona Paula features a jetty, an iconic whitewashed ‘Image of India’ statue, and spectacular sunset views. It blends romantic legend, colonial history, and panoramic sea vistas just outside Panaji."
  },
  {
    "title": "Goa Carnival & Cultural Festivities",
    "description": "Held annually in February or early March, the Goa Carnival is a lively three-day festival featuring reggae floats, samba dances, street parades, music, food stalls, and masquerade balls. Rooted in Catholic traditions and influenced by Rio’s Carnival, it showcases Goa’s vibrant cultural fusion."
  }
],

  "services": [
    {
      "name": "Pune to Goa Cab",
      "description": "Book a cab from Pune to Goa with Meghana Cab for a scenic and enjoyable coastal road trip. Choose from sedans, SUVs, or premium vehicles for your holiday travel, and enjoy professional service throughout the journey."
    },
    {
      "name": "One Way Outstation Cab Pune",
      "description": "Need a drop-off in another city? Book a one-way outstation cab from Pune and save on travel costs. Meghana Cab offers a wide fleet of vehicles with timely pickup and convenient booking options for one-way trips."
    },
    {
      "name": "Round Trip Outstation Cabs Pune",
      "description": "Choose our round trip outstation cab services from Pune for a complete travel solution. Ideal for weekend getaways, business meetings, or family trips, our round trip packages are flexible, cost-effective, and come with reliable support."
    },
    {
      "name": "SUV Rental for Outstation Pune",
      "description": "Planning a group or family outing? Our spacious SUVs are perfect for outstation travel from Pune. Enjoy ample legroom, luggage space, and a powerful ride for long highway journeys with Meghana Cab."
    },
    {
      "name": "Sedan Outstation Cabs from Pune",
      "description": "For comfortable and budget-friendly travel, book our sedan cabs for outstation journeys from Pune. Ideal for small families or solo travelers, our sedans offer AC comfort and clean interiors for a relaxed ride."
    },
    {
      "name": "Affordable Outstation Travel from Pune",
      "description": "Meghana Cab provides affordable outstation travel options from Pune without compromising on service quality. Get the best prices, well-maintained vehicles, and courteous drivers for your journey."
    },
    {
      "name": "Online Outstation Booking Pune",
      "description": "Enjoy the convenience of online outstation cab booking from Pune with Meghana Cab. Select your destination, vehicle type, and schedule—all within minutes. Safe, easy, and fully digital process."
    },
    {
      "name": "Weekend Outstation Cab Pune",
      "description": "Planning a weekend trip out of Pune? Meghana Cab offers special weekend cab packages for popular destinations like Lonavala, Mahabaleshwar, Shirdi, and more—perfect for quick getaways with friends or family."
    },
    {
      "name": "24/7 Outstation Taxi Service Pune",
      "description": "Travel at any time with our 24/7 outstation taxi service from Pune. Whether it’s an early morning pickup or a late-night drop, Meghana Cab is available round-the-clock for all your intercity travel needs."
    }
  ],
  "tableData": [
    ["Pune to Goa Cab", "One Way Outstation Cab Pune"],
    ["Round Trip Outstation Cabs Pune", "SUV Rental for Outstation Pune"],
    ["Sedan Outstation Cabs from Pune", "Affordable Outstation Travel from Pune"],
    ["Online Outstation Booking Pune", "Weekend Outstation Cab Pune"],
    ["24/7 Outstation Taxi Service Pune", ""]
  ],









"whychoose": [
    {
        "WhyChooseheading": "Comfortable and Scenic Pune to Goa Taxi Service",
        "WhyChoosedescription": "Meghana Cab offers a premium taxi service from Pune to Goa, making your long-distance travel as relaxing as your destination. Enjoy scenic routes through the Western Ghats, personalized stops, and a comfortable journey in our well-maintained vehicles."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pune to Goa Taxi Fare",
        "WhyChoosedescription": "We provide fixed, competitive taxi fares for Pune to Goa travel with no hidden charges. Our pricing includes fuel, driver allowance, tolls, and taxes—giving you full clarity and peace of mind for the 8- to 10-hour trip."
    },
    {
        "WhyChooseheading": "Wide Range of Cabs to Suit Your Travel Style",
        "WhyChoosedescription": "Choose from a variety of vehicle options including hatchbacks, sedans, SUVs, and tempo travellers—ideal for solo travelers, families, couples, or large groups heading to Goa for a beach vacation or celebration."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Long-Distance Highway Routes",
        "WhyChoosedescription": "Our drivers are trained for intercity routes and long drives, familiar with both the NH66 (via Kolhapur) and NH48 (via Belgaum) highways. They ensure safe, smooth travel with optional breaks for food and sightseeing en route."
    },
    {
        "WhyChooseheading": "Flexible Travel Options: One-Way, Round Trip, or Multi-Day Booking",
        "WhyChoosedescription": "Planning a one-way drop or a multi-day vacation in Goa? Meghana Cab offers flexible booking plans to suit your trip length and itinerary. You can also book a cab for Goa sightseeing while you’re there."
    },
    {
        "WhyChooseheading": "24/7 Availability for Early Morning or Overnight Travel",
        "WhyChoosedescription": "Whether you're catching a sunrise on the beach or heading out after work, our Pune to Goa taxis are available round-the-clock. We accommodate early departures and overnight journeys for your convenience."
    },
    {
        "WhyChooseheading": "Quick Booking with Real-Time Driver Updates",
        "WhyChoosedescription": "Book instantly via our website, app, or helpline. Get real-time driver details, live location tracking, and round-the-clock customer support for a worry-free experience from start to finish."
    },
    {
        "WhyChooseheading": "Perfect for Vacations, Honeymoons, and Group Trips",
        "WhyChoosedescription": "Whether you're planning a beach holiday, honeymoon, college reunion, or family getaway, Meghana Cab’s Pune to Goa taxi service ensures you arrive refreshed and ready to enjoy your time in Goa."
    }
]













































    }

const faqData = [
    {
        question: "How can I book a taxi from Pune to Goa with Meghana Cab?",
        answer: "You can easily book a Pune to Goa taxi by calling Meghana Cab at +91 9075462128 or through our website."
    },
    {
        question: "What types of vehicles are available for Pune to Goa trips?",
        answer: "We offer sedans, SUVs, and tempo travellers depending on your group size and comfort preferences."
    },
    {
        question: "Are Meghana Cab drivers experienced with the Pune to Goa route?",
        answer: "Yes, our drivers are knowledgeable about the best routes to ensure a safe and comfortable journey."
    },
    {
        question: "Can I book a one-way or round-trip taxi from Pune to Goa?",
        answer: "Yes, both one-way and round-trip taxi services are available."
    },
    {
        question: "What is included in the Pune to Goa taxi fare?",
        answer: "The fare covers driver charges, fuel, tolls, and vehicle maintenance. Additional charges may apply depending on your trip specifics."
    },
    {
        question: "Are Meghana Cab vehicles sanitized for Pune to Goa trips?",
        answer: "Yes, all vehicles are regularly cleaned and sanitized to ensure your safety and comfort."
    },
    {
        question: "Is Meghana Cab available 24/7 for Pune to Goa bookings?",
        answer: "Yes, our services operate round-the-clock to fit your travel plans."
    },
    {
        question: "Can I request special requirements like child seats for Pune to Goa trips?",
        answer: "Yes, special requests can be accommodated during booking."
    },
    {
        question: "What payment methods are accepted for Pune to Goa taxi bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash."
    },
    {
        question: "How can I contact Meghana Cab for Pune to Goa taxi services?",
        answer: "Call Meghana Cab at +91 9075462128 to book or inquire about Pune to Goa taxi services."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Rohit Desai',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Our Pune to Goa trip with Meghana Cab was comfortable and hassle-free. Highly recommended!”',
    },
    {
        name: 'Ms. Ananya Rao',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Professional driver and clean vehicle made our Pune to Goa journey enjoyable.”',
    },
];








































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const goaTaxiSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Goa Taxi Service",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-goa-cab.jpg",
  "description": "Book comfortable and affordable Pune to Goa taxi services with Meghana Cabs. One way, round trip, AC cabs, SUVs, sedans, and family travel options available.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": [
    "One Way Taxi Pune to Goa",
    "Round Trip Cab Pune to Goa",
    "AC Cab Hire Pune to Goa",
    "SUV and Sedan Rental",
    "Family and Group Travel Cabs"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Pune to Goa Taxi Offers",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "One Way Taxi Pune to Goa"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Round Trip Cab Pune to Goa"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "SUV Taxi Pune to Goa"
        }
      }
    ]
  }
};



    return (
        <div>

<Helmet>
  <title>Pune to Goa Taxi | Meghana Cabs</title>
  <meta
    name="description"
    content="Book comfortable and affordable Pune to Goa taxi services with Meghana Cabs. One way, round trip, AC cabs, SUVs, sedans, and family travel options available."
  />
  <meta
    name="keywords"
    content="Pune to Goa One Way Taxi, Goa Holiday Cab Pune, Round Trip Cab Pune to Goa, AC Cab Hire Pune to Goa, Budget Pune to Goa Taxi, Online Goa Taxi Booking from Pune, SUV Taxi Pune to Goa Trip, Sedan Hire Pune to Goa, Pune to Goa Beach Trip Cab, Long Drive Cab Pune to Goa, Pune to Goa Road Trip Taxi, Premium Cab Pune to Goa, Group Travel Cab Pune to Goa, Pune to Goa Weekend Travel Taxi, Family Cab Hire Pune to Goa"
  />
  <script type="application/ld+json">
    {JSON.stringify(goaTaxiSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/41.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetogoataxi;